import React from "react";
import {connect} from "react-redux";
import {Form, Icon, Input, Button} from "antd";


export const authorizationLayouts = {
    login: 0,
    registrationCoworker: 1,
    registrationOrganization: 2,
    forgotPassword: 3
}

const ForgotPasswordFrom = React.lazy(() => import("./forgotPasswordFrom")),
RegistrationForm = React.lazy(() => import("./registrationForm"));

class LForm extends React.Component {

    state = {
        layout: authorizationLayouts.login
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) this.props.login(values);
        });
    }

    changeLayout = layout => this.setState({layout})

    render() {
        const self = this,
        {layout} = self.state,
        {setting, form} = self.props,
        {getFieldDecorator} = form;

        switch (layout) {
            case authorizationLayouts.login:
                return (
                    <div>
                        <Form onSubmit={self.handleSubmit} className="login-form">
                            <Form.Item>
                                {getFieldDecorator('name', {
                                    rules: [{ required: true, message: 'Пожалуйста, введите ваш логин!' }],
                                })(
                                    <Input size="large" prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}} />} placeholder="Логин" />
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: 'Пожалуйста, введите ваш пароль!' }],
                                })(
                                    <Input size="large" prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}} />} type="password" placeholder="Пароль" />
                                )}
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" icon="login" block size="large" htmlType="submit" className="login-form-button">
                                    Войти в систему
                                </Button>
                            </Form.Item>
                            {setting.showForgotPassword?(
                                <footer>
                                    {/* <Button block onClick={() => self.changeLayout(authorizationLayouts.registrationOrganization)} type="link">
                                        Зарегистрироваться как организация
                                    </Button>
                                    <Button block onClick={() => self.changeLayout(authorizationLayouts.registrationCoworker)} type="link">
                                        Зарегистрироваться как сотрудник ИКЕА
                                    </Button> */}
                                    <Button block onClick={() => self.changeLayout(authorizationLayouts.forgotPassword)} type="link">
                                        Вспомнить пароль
                                    </Button>
                                </footer>
                            ):null}
                        </Form>
                    </div>
                );
            case authorizationLayouts.registrationOrganization:
            case authorizationLayouts.registrationCoworker:
                return (
                    <RegistrationForm 
                        isOrganization={layout === authorizationLayouts.registrationCoworker? false: true}
                        changeToLogin={() => self.changeLayout(authorizationLayouts.login)}
                        changeToForgotPassword={() => self.changeLayout(authorizationLayouts.forgotPassword)}/>
                )
            case authorizationLayouts.forgotPassword:
                return <ForgotPasswordFrom changeToLogin={() => self.changeLayout(authorizationLayouts.login)}/>
            default:
                return null;
        }
    }
}

const mapState = state => {
    return {
        setting: state.setting
    };
},
mapDispatch = dispatch => {
    return {
        login: form => dispatch.state.login(form)
    };
}

const ConnectedForm = Form.create({name: 'normal_login'})(LForm);
const LoginForm = connect(mapState, mapDispatch)(ConnectedForm);
export default LoginForm;
